import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { TimeService } from "@app2/shared/services/time.service";

export interface DateTimeTz {
    datetime: date; // ISO String
    timezone: string;
}

@Component({
    selector: "date-time-tz-picker",
    template: `
        <label>{{ 'TIME_ZONE' | localize }}</label>
        <timezone-picker [timezone]="timezone"
                         (timezoneChange)="onTimeZoneChanged($event)">
        </timezone-picker>
        <label>{{ 'TIME' | localize }}</label>
        <time-picker [time]="timeString"
                     (setTime)="onTimeChanged($event)">
        </time-picker>
        <label>{{ 'DAY' | localize }}</label>
        <date-picker [date]="dateString"
                     (dateChange)="onDateChanged($event)">
        </date-picker>
    `,
})
export class DateTimeTzPickerComponent implements OnChanges {
    @Input() datetime: date; // ISO String
    @Input() timezone: string;

    // eslint-disable-next-line @angular-eslint/no-output-on-prefix
    @Output() onChanged = new EventEmitter<DateTimeTz>();

    dateString: string;
    timeString: string;

    constructor(private timeService: TimeService) {
    }

    ngOnChanges() {
        const asMoment = this.timeService.timeZoneMoment(this.datetime, this.timezone);
        this.dateString = asMoment.format(this.timeService.formats.timestampDate);
        this.timeString = asMoment.format(this.timeService.formats.timeNoZone);
    }

    onDateChanged(newDate: date) {
        this.dateString = newDate;
        this.onChanged.emit({ datetime: this.makeIsoString(), timezone: this.timezone });
    }

    onTimeChanged(newTime: string) {
        this.timeString = newTime;
        this.onChanged.emit({ datetime: this.makeIsoString(), timezone: this.timezone });
    }

    onTimeZoneChanged(timezone) {
        this.timezone = timezone;
        this.onChanged.emit({ datetime: this.makeIsoString(), timezone: this.timezone });
    }

    private makeIsoString() {
        const format = this.timeService.formats.timestampDate + " " + this.timeService.formats.timeNoZone;
        const fullMoment = this.timeService.parseTzDate(this.dateString + " " + this.timeString,
            format, this.timezone);
        return fullMoment.toISOString();
    }
}
